import React, { Component } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  Badge,
  Tab,
  Tabs,
  Offcanvas,
  InputGroup,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

export default class DeploymentConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      activeTab: "teams",
      // Teams
      teams: [],
      showTeamForm: false,
      isEditingTeam: false,
      teamId: "",
      teamName: "",
      teamType: "UI",
      teamLead_Id: "",
      teamLeadName: "",
      department: "",
      teamDescription: "",
      teamIsActive: "1",
      manager_Id: "",
      managerName: "",
      deploymentAssignee_Id: "",
      deploymentAssigneeName: "",
      // Deployment Users
      allEmployees: [],
      deploymentUsers: [],
      deploymentUserSearch: "",
      // Repos
      repos: [],
      showRepoForm: false,
      isEditingRepo: false,
      repoId: "",
      repoName: "",
      repoType: "UI",
      repoUrl: "",
      branchName: "main",
      project_Id: "",
      projectName: "",
      environment_Id: "",
      environmentName: "",
      repo_team_Id: "",
      serverPath: "",
      buildCommand: "",
      deployCommand: "",
      repoIsActive: "1",
      // Members
      members: [],
      showMemberForm: false,
      isEditingMember: false,
      memberId: "",
      member_team_Id: "",
      member_Id: "",
      memberName: "",
      memberRole: "Developer",
      memberIsActive: "1",
      // Dropdowns
      employees: [],
      environmentmaster: [],
      deploymentprojects: [],
      // Projects CRUD
      showProjectForm: false,
      isEditingProject: false,
      editProjectId: "",
      editProjectName: "",
      editProjectDescription: "",
      editProjectItprojectsId: "",
      editProjectIsActive: "1",
      // IT Projects dropdown
      itprojects: [],
      // Git Tokens
      gitTokens: [],
      showGitTokenForm: false,
      isEditingGitToken: false,
      editGitTokenId: "",
      editGitTokenName: "",
      editGitAccessToken: "",
      editGitTokenIsActive: "1",
      gitTokenColumns: [
        {
          name: "ID",
          selector: (row) => row.deploymentgittokens_Id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Token Name",
          selector: (row) => row.tokenName,
          sortable: true,
        },
        {
          name: "Active",
          selector: (row) => row.isActive,
          cell: (row) => (
            <Badge bg={row.isActive == 1 ? "success" : "secondary"}>
              {row.isActive == 1 ? "Yes" : "No"}
            </Badge>
          ),
          width: "80px",
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Button
                size="sm"
                variant="primary"
                className="me-1"
                onClick={() => this.editGitToken(row)}
              >
                <i className="bi bi-pen"></i>
              </Button>
              <Button
                size="sm"
                variant="danger"
                style={{ padding: "7px 9px" }}
                onClick={() => this.deleteGitToken(row)}
              >
                <i className="bi bi-trash"></i>
              </Button>
            </div>
          ),
          width: "120px",
        },
      ],
      projectColumns: [
        {
          name: "ID",
          selector: (row) => row.deploymentprojects_Id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Project Name",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Description",
          selector: (row) => row.description,
          cell: (row) => <span>{row.description || "-"}</span>,
        },
        {
          name: "IT Project",
          selector: (row) => row.itprojects_Id,
          cell: (row) => {
            if (!row.itprojects_Id) return <span>-</span>;
            const itp = this.state.itprojects.find(
              (p) => p.itprojectstable_Id == row.itprojects_Id,
            );
            return <span>{itp ? itp.projectName : row.itprojects_Id}</span>;
          },
        },
        {
          name: "Active",
          selector: (row) => row.isActive,
          cell: (row) => (
            <Badge bg={row.isActive == 1 ? "success" : "secondary"}>
              {row.isActive == 1 ? "Yes" : "No"}
            </Badge>
          ),
          width: "80px",
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Button
                size="sm"
                variant="primary"
                className="me-1"
                onClick={() => this.editProject(row)}
              >
                <i className="bi bi-pen"></i>
              </Button>
              <Button
                size="sm"
                variant="danger"
                style={{ padding: "7px 9px" }}
                onClick={() => this.deleteProject(row)}
              >
                <i className="bi bi-trash"></i>
              </Button>
            </div>
          ),
          width: "120px",
        },
      ],
      // Table columns
      teamColumns: [
        {
          name: "ID",
          selector: (row) => row.deploymentteams_Id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Team Name",
          selector: (row) => row.teamName,
          sortable: true,
        },
        {
          name: "Type",
          selector: (row) => row.teamType,
          cell: (row) => (
            <Badge
              bg={
                row.teamType === "UI"
                  ? "primary"
                  : row.teamType === "API"
                    ? "success"
                    : "warning"
              }
            >
              {row.teamType}
            </Badge>
          ),
          width: "90px",
        },
        {
          name: "Team Lead",
          selector: (row) => row.teamLeadName,
        },
        {
          name: "Manager",
          selector: (row) => row.managerName,
          cell: (row) => <span>{row.managerName || "-"}</span>,
        },
        {
          name: "DevOps Assignee",
          selector: (row) => row.deploymentAssigneeName,
          cell: (row) => <span>{row.deploymentAssigneeName || "-"}</span>,
        },
        {
          name: "Department",
          selector: (row) => row.department,
        },
        {
          name: "Active",
          selector: (row) => row.isActive,
          cell: (row) => (
            <Badge bg={row.isActive == 1 ? "success" : "secondary"}>
              {row.isActive == 1 ? "Yes" : "No"}
            </Badge>
          ),
          width: "80px",
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Button
                size="sm"
                variant="primary"
                className="me-1"
                onClick={() => this.editTeam(row)}
              >
                <i className="bi bi-pen"></i>
              </Button>
              <Button
                size="sm"
                variant="danger"
                style={{ padding: "7px 9px" }}
                onClick={() => this.deleteTeam(row)}
              >
                <i className="bi bi-trash"></i>
              </Button>
            </div>
          ),
          width: "120px",
        },
      ],
      repoColumns: [
        {
          name: "ID",
          selector: (row) => row.deploymentrepos_Id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Repo Name",
          selector: (row) => row.repoName,
          sortable: true,
        },
        {
          name: "Type",
          selector: (row) => row.repoType,
          cell: (row) => (
            <Badge bg={row.repoType === "UI" ? "primary" : "success"}>
              {row.repoType}
            </Badge>
          ),
          width: "80px",
        },
        {
          name: "Branch",
          selector: (row) => row.branchName,
          width: "100px",
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
        },
        {
          name: "Environment",
          selector: (row) => row.environmentName,
          width: "120px",
        },
        {
          name: "Server Path",
          selector: (row) => row.serverPath,
          wrap: true,
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Button
                size="sm"
                variant="primary"
                className="me-1"
                onClick={() => this.editRepo(row)}
              >
                <i className="bi bi-pen"></i>
              </Button>
              <Button
                size="sm"
                variant="danger"
                style={{ padding: "7px 9px" }}
                onClick={() => this.deleteRepo(row)}
              >
                <i className="bi bi-trash"></i>
              </Button>
            </div>
          ),
          width: "120px",
        },
      ],
      memberColumns: [
        {
          name: "ID",
          selector: (row) => row.deploymentteammembers_Id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Team",
          selector: (row) => row.teamName,
          sortable: true,
        },
        {
          name: "Team Type",
          selector: (row) => row.teamType,
          cell: (row) => (
            <Badge
              bg={
                row.teamType === "UI"
                  ? "primary"
                  : row.teamType === "API"
                    ? "success"
                    : "warning"
              }
            >
              {row.teamType}
            </Badge>
          ),
          width: "100px",
        },
        {
          name: "Member Name",
          selector: (row) => row.memberName,
          sortable: true,
        },
        {
          name: "Role",
          selector: (row) => row.memberRole,
          cell: (row) => (
            <Badge
              bg={
                row.memberRole === "TechLead"
                  ? "info"
                  : row.memberRole === "DevOps"
                    ? "warning"
                    : "secondary"
              }
            >
              {row.memberRole}
            </Badge>
          ),
          width: "110px",
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Button
                size="sm"
                variant="primary"
                className="me-1"
                onClick={() => this.editMember(row)}
              >
                <i className="bi bi-pen"></i>
              </Button>
              <Button
                size="sm"
                variant="danger"
                style={{ padding: "7px 9px", marginTop: "0px" }}
                onClick={() => this.deleteMember(row)}
              >
                <i className="bi bi-trash"></i>
              </Button>
            </div>
          ),
          width: "120px",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchTeams();
    this.fetchRepos();
    this.fetchMembers();
    this.fetchEmployees();
    this.fetchDeploymentUsers();
    this.fetchAllEmployees();
    this.fetchEnvironments();
    this.fetchProjects();
    this.fetchGitTokens();
    this.fetchItProjects();
  }

  // === FETCH ===
  fetchTeams = () => {
    fetch(configData.api_url + "C_Deploymentteams/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") this.setState({ teams: data.list });
      })
      .catch((e) => console.error(e));
  };

  fetchRepos = () => {
    fetch(configData.api_url + "C_Deploymentrepos/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") this.setState({ repos: data.list });
      })
      .catch((e) => console.error(e));
  };

  fetchMembers = () => {
    fetch(configData.api_url + "C_Deploymentteammembers/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") this.setState({ members: data.list });
      })
      .catch((e) => console.error(e));
  };

  fetchEmployees = () => {
    fetch(configData.api_url + "C_Employees/listDeploymentUsers", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ employees: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  fetchDeploymentUsers = () => {
    fetch(configData.api_url + "C_Employees/listDeploymentUsers", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ deploymentUsers: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  fetchAllEmployees = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/listActive", {
      method: "POST",
      body: formData,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ allEmployees: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  toggleDeploymentUser = (emp, isEnabled) => {
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("employees_Id", emp.employees_Id);
    fd.append("isDeploymentUser", isEnabled ? "1" : "0");
    fetch(configData.api_url + "C_Employees/toggleDeploymentUser", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          this.fetchAllEmployees();
          this.fetchDeploymentUsers();
          this.fetchEmployees();
        }
      })
      .catch((e) => console.error(e));
  };

  fetchEnvironments = () => {
    fetch(configData.api_url + "C_Environmentmaster/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ environmentmaster: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  fetchProjects = () => {
    fetch(configData.api_url + "C_Deploymentprojects/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ deploymentprojects: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  fetchGitTokens = () => {
    fetch(configData.api_url + "C_Deploymentgittokens/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ gitTokens: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  fetchItProjects = () => {
    fetch(configData.api_url + "C_Itprojectstable/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success")
          this.setState({ itprojects: data.list || [] });
      })
      .catch((e) => console.error(e));
  };

  // === GIT TOKENS CRUD ===
  editGitToken = (row) => {
    this.setState({
      showGitTokenForm: true,
      isEditingGitToken: true,
      editGitTokenId: row.deploymentgittokens_Id,
      editGitTokenName: row.tokenName || "",
      editGitAccessToken: "",
      editGitTokenIsActive: row.isActive || "1",
    });
  };

  saveGitToken = () => {
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("tokenName", this.state.editGitTokenName);
    if (this.state.editGitAccessToken) {
      fd.append("gitAccessToken", this.state.editGitAccessToken);
    }
    fd.append("isActive", this.state.editGitTokenIsActive);

    let url = "C_Deploymentgittokens/add";
    if (this.state.isEditingGitToken) {
      fd.append("deploymentgittokens_Id", this.state.editGitTokenId);
      url = "C_Deploymentgittokens/update";
    }

    fetch(configData.api_url + url, { method: "POST", body: fd })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        if (data.status === "success") {
          this.setState({ showGitTokenForm: false });
          this.fetchGitTokens();
        }
      })
      .catch(() => toast.error("Failed to save git token"));
  };

  deleteGitToken = (row) => {
    if (!window.confirm("Delete this git token?")) return;
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentgittokens_Id", row.deploymentgittokens_Id);
    fetch(configData.api_url + "C_Deploymentgittokens/delete", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.fetchGitTokens();
      });
  };

  // === TEAMS CRUD ===
  editTeam = (row) => {
    this.setState({
      showTeamForm: true,
      isEditingTeam: true,
      teamId: row.deploymentteams_Id,
      teamName: row.teamName || "",
      teamType: row.teamType || "UI",
      teamLead_Id: row.teamLead_Id || "",
      teamLeadName: row.teamLeadName || "",
      manager_Id: row.manager_Id || "",
      managerName: row.managerName || "",
      deploymentAssignee_Id: row.deploymentAssignee_Id || "",
      deploymentAssigneeName: row.deploymentAssigneeName || "",
      department: row.department || "",
      teamDescription: row.description || "",
      teamIsActive: row.isActive || "1",
    });
  };

  saveTeam = () => {
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("teamName", this.state.teamName);
    fd.append("teamType", this.state.teamType);
    fd.append("teamLead_Id", this.state.teamLead_Id);
    fd.append("teamLeadName", this.state.teamLeadName);
    fd.append("manager_Id", this.state.manager_Id);
    fd.append("managerName", this.state.managerName);
    fd.append("deploymentAssignee_Id", this.state.deploymentAssignee_Id);
    fd.append("deploymentAssigneeName", this.state.deploymentAssigneeName);
    fd.append("department", this.state.department);
    fd.append("description", this.state.teamDescription);
    fd.append("isActive", this.state.teamIsActive);

    let url = "C_Deploymentteams/add";
    if (this.state.isEditingTeam) {
      fd.append("deploymentteams_Id", this.state.teamId);
      url = "C_Deploymentteams/update";
    }

    fetch(configData.api_url + url, { method: "POST", body: fd })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        if (data.status === "success") {
          this.setState({ showTeamForm: false });
          this.fetchTeams();
        }
      })
      .catch(() => toast.error("Failed to save team"));
  };

  deleteTeam = (row) => {
    if (!window.confirm("Delete this team?")) return;
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentteams_Id", row.deploymentteams_Id);
    fetch(configData.api_url + "C_Deploymentteams/delete", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.fetchTeams();
      });
  };

  // === REPOS CRUD ===
  editRepo = (row) => {
    this.setState({
      showRepoForm: true,
      isEditingRepo: true,
      repoId: row.deploymentrepos_Id,
      repoName: row.repoName || "",
      repoType: row.repoType || "UI",
      repoUrl: row.repoUrl || "",
      branchName: row.branchName || "main",
      project_Id: row.project_Id || "",
      projectName: row.projectName || "",
      environment_Id: row.environment_Id || "",
      environmentName: row.environmentName || "",
      repo_team_Id: row.team_Id || "",
      serverPath: row.serverPath || "",
      buildCommand: row.buildCommand || "",
      deployCommand: row.deployCommand || "",
      repoIsActive: row.isActive || "1",
    });
  };

  saveRepo = () => {
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("repoName", this.state.repoName);
    fd.append("repoType", this.state.repoType);
    fd.append("repoUrl", this.state.repoUrl);
    fd.append("branchName", this.state.branchName);
    fd.append("project_Id", this.state.project_Id);
    fd.append("projectName", this.state.projectName);
    fd.append("environment_Id", this.state.environment_Id);
    fd.append("environmentName", this.state.environmentName);
    fd.append("team_Id", this.state.repo_team_Id);
    fd.append("serverPath", this.state.serverPath);
    fd.append("buildCommand", this.state.buildCommand);
    fd.append("deployCommand", this.state.deployCommand);
    fd.append("isActive", this.state.repoIsActive);

    let url = "C_Deploymentrepos/add";
    if (this.state.isEditingRepo) {
      fd.append("deploymentrepos_Id", this.state.repoId);
      url = "C_Deploymentrepos/update";
    }

    fetch(configData.api_url + url, { method: "POST", body: fd })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        if (data.status === "success") {
          this.setState({ showRepoForm: false });
          this.fetchRepos();
        }
      })
      .catch(() => toast.error("Failed to save repo"));
  };

  deleteRepo = (row) => {
    if (!window.confirm("Delete this repo?")) return;
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentrepos_Id", row.deploymentrepos_Id);
    fetch(configData.api_url + "C_Deploymentrepos/delete", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.fetchRepos();
      });
  };

  // === PROJECTS CRUD ===
  editProject = (row) => {
    this.setState({
      showProjectForm: true,
      isEditingProject: true,
      editProjectId: row.deploymentprojects_Id,
      editProjectName: row.projectName || "",
      editProjectDescription: row.description || "",
      editProjectItprojectsId: row.itprojects_Id || "",
      editProjectIsActive: row.isActive || "1",
    });
  };

  saveProject = () => {
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("projectName", this.state.editProjectName);
    fd.append("description", this.state.editProjectDescription);
    fd.append("itprojects_Id", this.state.editProjectItprojectsId);
    fd.append("isActive", this.state.editProjectIsActive);

    let url = "C_Deploymentprojects/add";
    if (this.state.isEditingProject) {
      fd.append("deploymentprojects_Id", this.state.editProjectId);
      url = "C_Deploymentprojects/update";
    }

    fetch(configData.api_url + url, { method: "POST", body: fd })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        if (data.status === "success") {
          this.setState({ showProjectForm: false });
          this.fetchProjects();
        }
      })
      .catch(() => toast.error("Failed to save project"));
  };

  deleteProject = (row) => {
    if (!window.confirm("Delete this project?")) return;
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentprojects_Id", row.deploymentprojects_Id);
    fetch(configData.api_url + "C_Deploymentprojects/delete", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.fetchProjects();
      });
  };

  // === MEMBERS CRUD ===
  editMember = (row) => {
    this.setState({
      showMemberForm: true,
      isEditingMember: true,
      memberId: row.deploymentteammembers_Id,
      member_team_Id: row.team_Id || "",
      member_Id: row.member_Id || "",
      memberName: row.memberName || "",
      memberRole: row.memberRole || "Developer",
      memberIsActive: row.isActive || "1",
    });
  };

  saveMember = () => {
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("team_Id", this.state.member_team_Id);
    fd.append("member_Id", this.state.member_Id);
    fd.append("memberName", this.state.memberName);
    fd.append("memberRole", this.state.memberRole);
    fd.append("isActive", this.state.memberIsActive);

    let url = "C_Deploymentteammembers/add";
    if (this.state.isEditingMember) {
      fd.append("deploymentteammembers_Id", this.state.memberId);
      url = "C_Deploymentteammembers/update";
    }

    fetch(configData.api_url + url, { method: "POST", body: fd })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        if (data.status === "success") {
          this.setState({ showMemberForm: false });
          this.fetchMembers();
        }
      })
      .catch(() => toast.error("Failed to save member"));
  };

  deleteMember = (row) => {
    if (!window.confirm("Remove this team member?")) return;
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentteammembers_Id", row.deploymentteammembers_Id);
    fetch(configData.api_url + "C_Deploymentteammembers/delete", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.fetchMembers();
      });
  };

  render() {
    return (
      <div className="container-fluid p-3">
        <h4>Deployment Configuration</h4>
        <p className="text-muted">
          Configure teams, repos, and team members for the deployment workflow.
        </p>

        <Tabs
          activeKey={this.state.activeTab}
          onSelect={(k) => this.setState({ activeTab: k })}
          className="mb-3"
        >
          {/* === DEPLOYMENT USERS TAB === */}
          <Tab
            eventKey="deploymentUsers"
            title={`Deployment Users (${
              this.state.allEmployees.filter((e) => e.isDeploymentUser == 1)
                .length
            })`}
          >
            <InputGroup className="mb-3" style={{ maxWidth: "300px" }}>
              <Form.Control
                type="text"
                placeholder="Search employees..."
                value={this.state.deploymentUserSearch}
                onChange={(e) =>
                  this.setState({ deploymentUserSearch: e.target.value })
                }
              />
            </InputGroup>
            <DataTable
              columns={[
                {
                  name: "ID",
                  selector: (row) => row.employees_Id,
                  sortable: true,
                  width: "70px",
                },
                {
                  name: "Emp ID",
                  selector: (row) => row.eId,
                  sortable: true,
                  width: "100px",
                },
                {
                  name: "Name",
                  selector: (row) =>
                    (row.fName || "") + " " + (row.lName || ""),
                  sortable: true,
                },
                {
                  name: "Department",
                  selector: (row) => row.dName,
                  sortable: true,
                },
                {
                  name: "Deployment User",
                  cell: (row) => (
                    <Form.Check
                      type="switch"
                      checked={row.isDeploymentUser == 1}
                      onChange={(e) =>
                        this.toggleDeploymentUser(row, e.target.checked)
                      }
                    />
                  ),
                  width: "140px",
                },
              ]}
              data={this.state.allEmployees.filter((e) => {
                const search = this.state.deploymentUserSearch.toLowerCase();
                if (!search) return true;
                return (
                  (e.fName || "").toLowerCase().includes(search) ||
                  (e.lName || "").toLowerCase().includes(search) ||
                  (e.eId || "").toLowerCase().includes(search) ||
                  (e.dName || "").toLowerCase().includes(search)
                );
              })}
              pagination
              highlightOnHover
              striped
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
              paginationPerPage={100}
              keyField="id"
            />
          </Tab>

          {/* === TEAMS TAB === */}
          <Tab eventKey="teams" title={`Teams (${this.state.teams.length})`}>
            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                this.setState({
                  showTeamForm: true,
                  isEditingTeam: false,
                  teamId: "",
                  teamName: "",
                  teamType: "UI",
                  teamLead_Id: "",
                  teamLeadName: "",
                  manager_Id: "",
                  managerName: "",
                  deploymentAssignee_Id: "",
                  deploymentAssigneeName: "",
                  department: "",
                  teamDescription: "",
                  teamIsActive: "1",
                })
              }
            >
              + Add Team
            </Button>
            <DataTable
              columns={this.state.teamColumns}
              data={this.state.teams}
              pagination
              highlightOnHover
              striped
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
            />
          </Tab>

          {/* === REPOS TAB === */}
          <Tab eventKey="repos" title={`Repos (${this.state.repos.length})`}>
            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                this.setState({
                  showRepoForm: true,
                  isEditingRepo: false,
                  repoId: "",
                  repoName: "",
                  repoType: "UI",
                  repoUrl: "",
                  branchName: "main",
                  project_Id: "",
                  projectName: "",
                  environment_Id: "",
                  environmentName: "",
                  repo_team_Id: "",
                  serverPath: "",
                  buildCommand: "",
                  deployCommand: "",
                  repoIsActive: "1",
                })
              }
            >
              + Add Repo
            </Button>
            <DataTable
              columns={this.state.repoColumns}
              data={this.state.repos}
              pagination
              highlightOnHover
              striped
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
            />
          </Tab>

          {/* === MEMBERS TAB === */}
          <Tab
            eventKey="members"
            title={`Team Members (${this.state.members.length})`}
          >
            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                this.setState({
                  showMemberForm: true,
                  isEditingMember: false,
                  memberId: "",
                  member_team_Id: "",
                  member_Id: "",
                  memberName: "",
                  memberRole: "Developer",
                  memberIsActive: "1",
                })
              }
            >
              + Add Member
            </Button>
            <DataTable
              columns={this.state.memberColumns}
              data={this.state.members}
              pagination
              highlightOnHover
              striped
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
            />
          </Tab>

          {/* === PROJECTS TAB === */}
          <Tab
            eventKey="projects"
            title={`Projects (${this.state.deploymentprojects.length})`}
          >
            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                this.setState({
                  showProjectForm: true,
                  isEditingProject: false,
                  editProjectId: "",
                  editProjectName: "",
                  editProjectDescription: "",
                  editProjectItprojectsId: "",
                  editProjectIsActive: "1",
                })
              }
            >
              + Add Project
            </Button>
            <DataTable
              columns={this.state.projectColumns}
              data={this.state.deploymentprojects}
              pagination
              highlightOnHover
              striped
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
            />
          </Tab>

          {/* === GIT TOKENS TAB === */}
          <Tab
            eventKey="gitTokens"
            title={`Git Tokens (${this.state.gitTokens.length})`}
          >
            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                this.setState({
                  showGitTokenForm: true,
                  isEditingGitToken: false,
                  editGitTokenId: "",
                  editGitTokenName: "",
                  editGitAccessToken: "",
                  editGitTokenIsActive: "1",
                })
              }
            >
              + Add Git Token
            </Button>
            <DataTable
              columns={this.state.gitTokenColumns}
              data={this.state.gitTokens}
              pagination
              highlightOnHover
              striped
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
            />
          </Tab>
        </Tabs>

        {/* === TEAM FORM === */}
        <Offcanvas
          show={this.state.showTeamForm}
          onHide={() => this.setState({ showTeamForm: false })}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {this.state.isEditingTeam ? "Edit Team" : "Add Team"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Team Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.teamName}
                  onChange={(e) => this.setState({ teamName: e.target.value })}
                  placeholder="e.g. UI Team, API Team"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Team Type</Form.Label>
                <Form.Select
                  value={this.state.teamType}
                  onChange={(e) => this.setState({ teamType: e.target.value })}
                >
                  <option value="UI">UI</option>
                  <option value="API">API</option>
                  <option value="DevOps">DevOps</option>
                  <option value="FullStack">FullStack</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Team Lead</Form.Label>
                <Form.Select
                  value={this.state.teamLead_Id}
                  onChange={(e) => {
                    const emp = this.state.employees.find(
                      (em) => em.employees_Id == e.target.value,
                    );
                    this.setState({
                      teamLead_Id: e.target.value,
                      teamLeadName: emp
                        ? (emp.fName || "") + " " + (emp.lName || "")
                        : "",
                    });
                  }}
                >
                  <option value="">-- Select Team Lead --</option>
                  {this.state.employees.map((emp) => (
                    <option key={emp.employees_Id} value={emp.employees_Id}>
                      {emp.fName} {emp.lName} - {emp.eId}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Manager (Second Approver)</Form.Label>
                <Form.Select
                  value={this.state.manager_Id}
                  onChange={(e) => {
                    const emp = this.state.employees.find(
                      (em) => em.employees_Id == e.target.value,
                    );
                    this.setState({
                      manager_Id: e.target.value,
                      managerName: emp
                        ? (emp.fName || "") + " " + (emp.lName || "")
                        : "",
                    });
                  }}
                >
                  <option value="">-- None (Skip Manager Approval) --</option>
                  {this.state.employees.map((emp) => (
                    <option key={emp.employees_Id} value={emp.employees_Id}>
                      {emp.fName} {emp.lName} - {emp.eId}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Deployment Assignee (DevOps)</Form.Label>
                <Form.Select
                  value={this.state.deploymentAssignee_Id}
                  onChange={(e) => {
                    const emp = this.state.employees.find(
                      (em) => em.employees_Id == e.target.value,
                    );
                    this.setState({
                      deploymentAssignee_Id: e.target.value,
                      deploymentAssigneeName: emp
                        ? (emp.fName || "") + " " + (emp.lName || "")
                        : "",
                    });
                  }}
                >
                  <option value="">-- Select DevOps Assignee --</option>
                  {this.state.employees.map((emp) => (
                    <option key={emp.employees_Id} value={emp.employees_Id}>
                      {emp.fName} {emp.lName} - {emp.eId}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Department</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.department}
                  onChange={(e) =>
                    this.setState({ department: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={this.state.teamDescription}
                  onChange={(e) =>
                    this.setState({ teamDescription: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Active"
                  checked={this.state.teamIsActive == "1"}
                  onChange={(e) =>
                    this.setState({
                      teamIsActive: e.target.checked ? "1" : "0",
                    })
                  }
                />
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={this.saveTeam}>
                  Save Team
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>

        {/* === REPO FORM === */}
        <Offcanvas
          show={this.state.showRepoForm}
          onHide={() => this.setState({ showRepoForm: false })}
          placement="end"
          style={{ width: "45%" }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {this.state.isEditingRepo ? "Edit Repo" : "Add Repo"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Repo Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.repoName}
                      onChange={(e) =>
                        this.setState({ repoName: e.target.value })
                      }
                      placeholder="e.g. playright, playright-api"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Repo Type</Form.Label>
                    <Form.Select
                      value={this.state.repoType}
                      onChange={(e) =>
                        this.setState({ repoType: e.target.value })
                      }
                    >
                      <option value="UI">UI</option>
                      <option value="API">API</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Repo URL (Git)</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.repoUrl}
                  onChange={(e) => this.setState({ repoUrl: e.target.value })}
                  placeholder="https://github.com/org/repo.git"
                />
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Branch</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.branchName}
                      onChange={(e) =>
                        this.setState({ branchName: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Assign to Team</Form.Label>
                    <Form.Select
                      value={this.state.repo_team_Id}
                      onChange={(e) =>
                        this.setState({ repo_team_Id: e.target.value })
                      }
                    >
                      <option value="">-- Select Team --</option>
                      {this.state.teams.map((t) => (
                        <option
                          key={t.deploymentteams_Id}
                          value={t.deploymentteams_Id}
                        >
                          {t.teamName} ({t.teamType})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project</Form.Label>
                    <Form.Select
                      value={this.state.project_Id}
                      onChange={(e) => {
                        const proj = this.state.deploymentprojects.find(
                          (p) => p.deploymentprojects_Id == e.target.value,
                        );
                        this.setState({
                          project_Id: e.target.value,
                          projectName: proj ? proj.projectName : "",
                        });
                      }}
                    >
                      <option value="">-- Select Project --</option>
                      {this.state.deploymentprojects.map((p) => (
                        <option
                          key={p.deploymentprojects_Id}
                          value={p.deploymentprojects_Id}
                        >
                          {p.projectName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Environment</Form.Label>
                    <Form.Select
                      value={this.state.environmentName}
                      onChange={(e) =>
                        this.setState({ environmentName: e.target.value })
                      }
                    >
                      <option value="">-- Select Environment --</option>
                      {this.state.environmentmaster.map((env) => (
                        <option
                          key={env.environmentmaster_Id}
                          value={env.environmentName}
                        >
                          {env.environmentName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Server Deploy Path</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.serverPath}
                  onChange={(e) =>
                    this.setState({ serverPath: e.target.value })
                  }
                  placeholder="/var/www/html/project"
                />
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Build Command</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.buildCommand}
                      onChange={(e) =>
                        this.setState({ buildCommand: e.target.value })
                      }
                      placeholder="npm run build"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Deploy Command</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.deployCommand}
                      onChange={(e) =>
                        this.setState({ deployCommand: e.target.value })
                      }
                      placeholder="rsync -avz build/ server:/path"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={this.saveRepo}>
                  Save Repo
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>

        {/* === MEMBER FORM === */}
        <Offcanvas
          show={this.state.showMemberForm}
          onHide={() => this.setState({ showMemberForm: false })}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {this.state.isEditingMember ? "Edit Member" : "Add Member"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Team</Form.Label>
                <Form.Select
                  value={this.state.member_team_Id}
                  onChange={(e) =>
                    this.setState({ member_team_Id: e.target.value })
                  }
                >
                  <option value="">-- Select Team --</option>
                  {this.state.teams.map((t) => (
                    <option
                      key={t.deploymentteams_Id}
                      value={t.deploymentteams_Id}
                    >
                      {t.teamName} ({t.teamType})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Employee</Form.Label>
                <Form.Select
                  value={this.state.member_Id}
                  onChange={(e) => {
                    const emp = this.state.employees.find(
                      (em) => em.employees_Id == e.target.value,
                    );
                    this.setState({
                      member_Id: e.target.value,
                      memberName: emp
                        ? (emp.fName || "") + " " + (emp.lName || "")
                        : "",
                    });
                  }}
                >
                  <option value="">-- Select Employee --</option>
                  {this.state.employees.map((emp) => (
                    <option key={emp.employees_Id} value={emp.employees_Id}>
                      {emp.fName} {emp.lName} - {emp.eId}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  value={this.state.memberRole}
                  onChange={(e) =>
                    this.setState({ memberRole: e.target.value })
                  }
                >
                  <option value="Developer">Developer</option>
                  <option value="SeniorDev">Senior Developer</option>
                  <option value="TechLead">Tech Lead</option>
                  <option value="DevOps">DevOps</option>
                </Form.Select>
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={this.saveMember}>
                  Save Member
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>

        {/* === PROJECT FORM === */}
        <Offcanvas
          show={this.state.showProjectForm}
          onHide={() => this.setState({ showProjectForm: false })}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {this.state.isEditingProject ? "Edit Project" : "Add Project"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Project Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.editProjectName}
                  onChange={(e) =>
                    this.setState({ editProjectName: e.target.value })
                  }
                  placeholder="e.g. Playright, HRApp"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={this.state.editProjectDescription}
                  onChange={(e) =>
                    this.setState({ editProjectDescription: e.target.value })
                  }
                  placeholder="Project description"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>IT Project</Form.Label>
                <Form.Select
                  value={this.state.editProjectItprojectsId}
                  onChange={(e) =>
                    this.setState({ editProjectItprojectsId: e.target.value })
                  }
                >
                  <option value="">-- None --</option>
                  {this.state.itprojects.map((p) => (
                    <option
                      key={p.itprojectstable_Id}
                      value={p.itprojectstable_Id}
                    >
                      {p.projectName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Text className="text-muted">
                  Link this deployment project to an IT project for automatic
                  task creation.
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Active</Form.Label>
                <Form.Select
                  value={this.state.editProjectIsActive}
                  onChange={(e) =>
                    this.setState({ editProjectIsActive: e.target.value })
                  }
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Form.Select>
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={this.saveProject}>
                  Save Project
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>

        {/* === GIT TOKEN FORM === */}
        <Offcanvas
          show={this.state.showGitTokenForm}
          onHide={() => this.setState({ showGitTokenForm: false })}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {this.state.isEditingGitToken
                ? "Edit Git Token"
                : "Add Git Token"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Token Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.editGitTokenName}
                  onChange={(e) =>
                    this.setState({ editGitTokenName: e.target.value })
                  }
                  placeholder="e.g. Main GitHub Token"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>GitHub Access Token</Form.Label>
                <Form.Control
                  type="password"
                  value={this.state.editGitAccessToken}
                  onChange={(e) =>
                    this.setState({ editGitAccessToken: e.target.value })
                  }
                  placeholder={
                    this.state.isEditingGitToken
                      ? "Leave blank to keep existing token"
                      : "ghp_xxxxxxxxxxxx"
                  }
                />
                <Form.Text className="text-muted">
                  Personal access token for fetching repo file trees from
                  GitHub.
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Active</Form.Label>
                <Form.Select
                  value={this.state.editGitTokenIsActive}
                  onChange={(e) =>
                    this.setState({ editGitTokenIsActive: e.target.value })
                  }
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Form.Select>
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={this.saveGitToken}>
                  Save Token
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    );
  }
}
